import { routesWithPageTitles } from "../routes";

export const getLastPageCollected = (pathname: string) => {
	const currentRoute = routesWithPageTitles.find(
		(route) => route.path === pathname
	);
	return currentRoute?.pageTitle ?? "";
};
